import type { CmmdProjectUpdateStatus, CmmdProjectUpdateView } from "@cmmd-forge/contracts";

import { Button } from "../ui/button";
import { ProjectUpdatesSection } from "./CmmdProjectOverviewUpdates";

export interface CmmdProjectUpdatesTabProps {
  readonly projectId: string;
  readonly updates: readonly CmmdProjectUpdateView[];
  readonly total: number;
  readonly hasMore: boolean;
  readonly loading: boolean;
  readonly error: string | null;
  readonly onAdd: (input: {
    readonly status: CmmdProjectUpdateStatus;
    readonly body: string;
  }) => Promise<void>;
  readonly onUpdate: (
    updateId: string,
    input: { readonly status: CmmdProjectUpdateStatus; readonly body: string },
  ) => Promise<void>;
  readonly onDelete: (updateId: string) => Promise<void>;
  readonly onLoadMore: () => Promise<void>;
}

export function CmmdProjectUpdatesTab(props: CmmdProjectUpdatesTabProps) {
  return (
    <div className="mx-auto w-full max-w-3xl px-5 py-6 sm:px-8">
      <ProjectUpdatesSection
        projectId={props.projectId}
        updates={props.updates}
        loading={props.loading}
        error={props.error}
        onAdd={props.onAdd}
        onUpdate={props.onUpdate}
        onDelete={props.onDelete}
      />
      {props.updates.length > 0 ? (
        <div className="mt-6 flex items-center justify-between gap-3 pt-2">
          <p className="text-xs text-muted-foreground">
            Showing {props.updates.length} of {props.total}
          </p>
          {props.hasMore ? (
            <Button
              type="button"
              variant="outline"
              size="sm"
              disabled={props.loading}
              onClick={() => void props.onLoadMore()}
            >
              {props.loading ? "Loading…" : "Load 10 older updates"}
            </Button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
